package de.xtl.retroguide

import de.xtl.retroguide.protocol.ActionItem
import de.xtl.retroguide.protocol.VisibleAnswer
import de.xtl.retroguide.protocol.VotingOption
import de.xtl.retroguide.protocol.toCategorizedAnswer
import de.xtl.retroguide.protocol.toDotVote

internal data class RankedOption(val option: VotingOption, val points: Int)

/** Points per option, highest first; ties keep the option order, votes for unknown options are ignored. */
internal fun votingRanking(options: List<VotingOption>, votes: List<VisibleAnswer>): List<RankedOption> {
    val points = votes.mapNotNull { it.content.toDotVote() }
        .flatMap { it.votes.entries }
        .groupBy({ it.key }, { it.value })
        .mapValues { (_, counts) -> counts.sum() }
    return options
        .map { RankedOption(it, points[it.id] ?: 0) }
        .sortedByDescending { it.points }
}

/** Readable answer text without the category prefix. */
internal val VisibleAnswer.plainText: String
    get() = content.toCategorizedAnswer()?.text ?: content

internal val ActionItem.summary: String
    get() = buildString {
        append(what)
        if (who.isNotBlank()) append(" – ").append(who)
        if (due.isNotBlank()) append(" (bis ").append(due).append(")")
    }
